import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { catchError, Observable } from "rxjs";
import { MainService } from "./main.service";
import { LocalStorageService } from "./localStorage.service";
@Injectable({
    providedIn: 'root'
})
export class LoginService {
    
    readonly authenticateUrl = 'authenticateEntreprise';
    readonly resetPasswordUrl = 'entreprise/resetPassword';
    
    constructor(private http: HttpClient, private mainService: MainService, private localStorageService: LocalStorageService) {}

    authenticate(data: unknown) : Observable<any>{ 
        return this.http.post(environment.BASE_URL + this.authenticateUrl , data).pipe(catchError(err => this.mainService.handleError(err)));
    }

    resetPassword(data: unknown) : Observable<any>{
        return this.http.post(environment.BASE_URL + this.resetPasswordUrl , data).pipe(catchError(err => this.mainService.handleError(err)));
    }
    
    getAccount(){
       return this.localStorageService.getItem("entreprise");
    }

    getToken() {
        const account = this.getAccount();     
        return account ? account["Token"]: "";
    }

    getCountryCode() {
        const account = this.getAccount();     
        return account ? account["CodePays"]: "";
    }
}